import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { isEmptyObject } from 'jquery';

import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';

class ListMenu extends Component {
  constructor(props){
    super(props);
    this.state = {
      checkedMenu: [],
      webMenu: [],
      mobileMenu: []
    }

    this.stateParams = window.history.state.state;
  }

  componentDidMount(){
    this.getAllMenu();
  };

  getAllMenu = () => {
    const payload = {
      params: {
        roleId: this.stateParams.selectedItem._id
      }
    };

    Services.getMenuAccessByRole(payload)
      .then(res => {
        this.setState({
          webMenu: res[0].webMenu,
          mobileMenu: res[1].mobileMenu
        }, () => {
          this.setCheckedMenu(this.state.webMenu);
          this.setCheckedMenu(this.state.mobileMenu);
        });
      })
      .catch(err => console.log(err));
  }

  setCheckedMenu = (arr = []) => {
    let tempArr = this.state.checkedMenu;

    arr.forEach(el => {
      if(!isEmptyObject(el.children)) {
        this.setCheckedMenu(el.children);
      }
      if(el.status === 1) tempArr.push(el.id);
    });

    this.setState({checkedMenu: tempArr});
  }

  handleCheckedMenuWeb = val => {
    let tempMenu = this.state.webMenu;
    let menuArr = val.target.value.split('.');
    let item = menuArr.length > 1 ? 
      tempMenu[menuArr[0]-1].children[menuArr[1]-1] : tempMenu[menuArr[0]-1];
    let tempArr = this.state.checkedMenu;

    if(tempArr.includes(item.id)) {
      tempArr = tempArr.filter(el => el !== item.id);
    } else {
      tempArr.push(item.id);
    }

    this.setState({ checkedMenu: tempArr });

    // if(menuArr.length > 1){
    //   const child = item.children[menuArr[0]-1];
    //   tempMenu[menuArr[0]-1].children[menuArr[1]-1].status = !child.status;
    // } else {
    //   tempMenu[menuArr[0]-1].status = !item.status;
    // }

    // this.setState({checkedMenu: tempMenu});
  }

  handleCheckedMenuMobile = val => {
    let tempMenu = this.state.mobileMenu;
    let menuArr = val.target.value.split('.');
    let item = menuArr.length > 1 ? 
      tempMenu[menuArr[0]-1].children[menuArr[1]-1] : tempMenu[menuArr[0]-1];
    let tempArr = this.state.checkedMenu;

    if(tempArr.includes(item.id)) {
      tempArr = tempArr.filter(el => el !== item.id);
    } else {
      tempArr.push(item.id);
    }

    this.setState({ checkedMenu: tempArr });
  }

  handleSubmitMenu = () => {
    if(isEmptyObject(this.stateParams)) return null;
    const param = this.stateParams.selectedItem;

    const payload = {
      roleId: param._id,
      menuAccess: this.state.checkedMenu
    }

    Services.postAddMenuAccess(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Data submitted successfully', 'top-right');
        this.setState({isForgotPassword: false})
        setTimeout(window.location.replace('/setting/role-access'));
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      })
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/user/dashboard">Home</Link></li>
        <li className="breadcrumb-item"><Link to="/setting/role-access">Role Management</Link></li>
        <li className="breadcrumb-item active">Menu Module</li>
      </ol>
      <h1 className="page-header">Menu Module </h1>
    </div>
  );

  renderTableRowWeb = (menu, index, number) => (
    <tr key={index}>
      <td className="with-checkbox">
        <div className="checkbox checkbox-css">
          <input 
            onChange={this.handleCheckedMenuWeb}
            value={number}
            type="checkbox"
            id={`table_checkbox_${number}`}
            checked={this.state.checkedMenu.includes(menu.id)} />
          <label htmlFor={`table_checkbox_${number}`}>&nbsp;</label>
        </div>
      </td>
      <td className="with-checkbox">{number}</td>
      <td className="with-checkbox">{menu.title}</td>
    </tr>
  );

  renderTableRowMobile = (menu, index, number) => (
    <tr key={index}>
      <td className="with-checkbox">
        <div className="checkbox checkbox-css">
          <input
            onChange={this.handleCheckedMenuMobile}
            value={number}
            type="checkbox"
            id={`table_checkbox_mobile_${number}`}
            checked={this.state.checkedMenu.includes(menu.id)}
          />
          <label htmlFor={`table_checkbox_mobile_${number}`}>&nbsp;</label>
        </div>
      </td>
      <td className="with-checkbox">{number}</td>
      <td className="with-checkbox">{menu.title}</td>
    </tr>
  )


  renderTableHeader = (title) => (
    <PanelHeader noButton={true}>
      <div className="d-flex justify-content-xl-between">
        <h5>{title}</h5>
      </div>
    </PanelHeader>
  )

  renderListWebMenuTable = () => {
    const { webMenu } = this.state;
    return(
      <div className="col-xl-12">
        <Panel>
          {this.renderTableHeader('List Web Menu')}
          <PanelBody>
          <div className="table-responsive">
            <table className="table table-striped m-b-0">
              <thead>
                <tr>
                  {/* <th className="with-checkbox">
                    <div className="checkbox checkbox-css">
                      <input type="checkbox" value="" id="table_checkbox_1" />
                      <label htmlFor="table_checkbox_1">&nbsp;</label>
                    </div>
                  </th> */}
                  <th>Checklist</th>
                  <th>Number</th>
                  <th>Menu Name</th>
                </tr>
              </thead>
              <tbody>
                {webMenu.map((item, index) => {
                  let number = `${index + 1}`;
                  return (
                    <Fragment>
                      {this.renderTableRowWeb(item, index, number)}
                      {item.children && item.children.map((submenu, i) => {
                        let subNumber = `${number}.${i+1}`;
                        return this.renderTableRowWeb(submenu, i, subNumber);
                      })}
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
          </PanelBody>
        </Panel>
      </div>
    )
  }

  renderListMobileMenuTable = () => {
    const { mobileMenu } = this.state;
    return(
      <div className="col-xl-12">
        <Panel>
          {this.renderTableHeader('List Mobile Menu')}
          <PanelBody>
          <div className="table-responsive">
            <table className="table table-striped m-b-0">
              <thead>
                <tr>
                  {/* <th className="with-checkbox">
                    <div className="checkbox checkbox-css">
                      <input type="checkbox" value="" id="table_checkbox_1" />
                      <label htmlFor="table_checkbox_1">&nbsp;</label>
                    </div>
                  </th> */}
                  <th>Checklist</th>
                  <th>Number</th>
                  <th>Menu Name</th>
                </tr>
              </thead>
              <tbody>
                {mobileMenu.map((item, index) => {
                  let number = `${index + 1}`;
                  return (
                    <Fragment>
                      {this.renderTableRowMobile(item, index, number)}
                      {item.children && item.children.map((submenu, i) => {
                        let subNumber = `${number}.${i+1}`;
                        return this.renderTableRowMobile(submenu, i, subNumber);
                      })}
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
          </PanelBody>
        </Panel>
      </div>
    )
  }



  render() {
    return(
      <div>
        {this.renderBreadcrumb()}
        <div className="row">
          {this.renderListWebMenuTable()}
          {this.renderListMobileMenuTable()}
        </div>
        <button className="btn btn-sm btn-primary width-70" onClick={this.handleSubmitMenu}>Submit</button>
    </div>
    )
  }
}

export default withNotification(ListMenu);